import { useMemo } from "react";
import { StreamsStore } from "views/stores/StreamsStore";
import { useStore } from "stores/connect";
const useModalData = (mappedData) => {
  const normalizedStreams = useStore(
    StreamsStore,
    ({ streams }) => Object.fromEntries(streams.map((stream) => [stream.id, { id: stream.id, title: stream.title }]))
  );
  return useMemo(() => {
    const {
      aggField = "",
      aggFunction = "",
      aggValue = "",
      columnGroupBy,
      rowGroupBy,
      streams,
      lutParameters,
      ...rest
    } = mappedData;
    const res = { ...rest };
    if (aggFunction) {
      res.aggCondition = `${aggFunction}(${aggField}): ${aggValue}`;
    }
    if (streams == null ? void 0 : streams.length) {
      res.streams = streams.map((id) => normalizedStreams[id].title).join(", ");
    }
    Object.entries({ columnGroupBy, rowGroupBy }).forEach(([key, entireValue]) => {
      if (entireValue) {
        res[key] = entireValue.join(", ");
      }
    });
    if (lutParameters) {
      res.lutParameters = lutParameters.map((param) => param.name).join(", ");
    }
    return res;
  }, [mappedData, normalizedStreams]);
};
export default useModalData;
